const lookUpKeys = {
  caregiver: "caregiversInFacility",
  resident: "residentsInFacility",
  staff: "staffInFacility",
  provider: "providersInFacility",
};

export function getLookUpKey(option: string) {
  if (
    typeof option === "string" &&
    option.startsWith("useLookup(") &&
    option.endsWith(")")
  ) {
    const key = option.slice(10, -1);
    if (key.includes("contactOnFacility")) {
      const arr = key.split(",");
      return arr.length === 2
        ? lookUpKeys[arr[1] as keyof typeof lookUpKeys]
        : arr[0];
    }
    return key;
  }
  return null;
}
